import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "landing-pages" */ "../views/LandingPage.vue")
  },
  {
    path: "/registration-page",
    name: "registration-page",
    component: () => import(/* webpackChunkName: "signup-pages" */ "../views/RegistrationPage.vue")
  },
  {
    path: "/signup-page",
    name: "signup-page",
    component: () => import(/* webpackChunkName: "signup-pages" */ "../views/SignupPage.vue")
  },
  {
    path: "/forgotten-password",
    name: "forgotten-password",
    component: () => import(/* webpackChunkName: "forgotten-pages" */ "../views/ForgottenPage.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import(/* webpackChunkName: "user-pages" */ "../views/Profile.vue")
  },
  {
    path: "/edit-page",
    name: "edit-page",
    component: () => import(/* webpackChunkName: "user-pages" */ "../views/Edit.vue")
  },
  // {
  //   path: "/",
  //   name: "lawyer-search",
  //   component: () => import(/* webpackChunkName: "landing-pages" */ "../views/LawyerSearch.vue")
  // },
  {
    path: "/",
    name: "search",
    component: () => import(/* webpackChunkName: "search-pages" */ "../views/NewSearchView.vue")
  },
  {
    path: "/search/affiliate=:id",
    name: "affiliate-search-details",
    component: () => import(/* webpackChunkName: "search-pages" */ "../views/NewSearchView.vue")
  },
  {
    path: "/email-editor",
    name: "email-editor",
    component: () => import(/* webpackChunkName: "user-pages" */ "../views/EmailEditor.vue")
  },
  {
    path: "/documents",
    name: "documents",
    component: () => import(/* webpackChunkName: "documents-pages" */ "../views/Documents.vue")
  },
  {
    path: "/calendar",
    name: "calendar",
    component: () => import(/* webpackChunkName: "calendar-pages" */ "../views/Calendar.vue")
  },
  {
    path: "/affiliate=:id",
    name: "search-details",
    component: () => import(/* webpackChunkName: "user-pages" */ "../views/SearchDetails.vue")
  },
  {
    path: "/score-card",
    name: "score-card",
    component: () => import(/* webpackChunkName: "user-pages" */ "../views/ScoreCard.vue")
  },
  {
    path: "*",
    name: "fallback",
    component: () => import(/* webpackChunkName: "landing-pages" */ "../views/NewSearchView.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
